import { render } from "./HomepageIlesdepaix.vue?vue&type=template&id=2f2be946&scoped=true"
import script from "./HomepageIlesdepaix.vue?vue&type=script&lang=js"
export * from "./HomepageIlesdepaix.vue?vue&type=script&lang=js"

import "./HomepageIlesdepaix.vue?vue&type=style&index=0&id=2f2be946&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2be946"]])

export default __exports__